import React, { useEffect, useRef } from "react";

import { isNonEmptyArray } from "_helpers";

import { 
    Card,
    Checkbox,
    Divider,
    Input,
    Select,
    Space
} from "antd";

import { ReactComponent as Delete } from "_assets/delete.svg";

export function FiltersDrawerContent({ 
    activeLeftMenuKeyGroup,
    currentSelectedMenu,
    externalFilters,
    gridApi, 
    users, 
    viewMode,
    defaultViewMode,
    attrAreVisible,
    assignmentIsVisible,
    priorityIsVisible,
    handleToggleColumns,
    setActiveLeftMenuKeyGroup,
    setExternalFilter,
    setViewMode,
    setAttrAreVisible,
    setAssignmentIsVisible,
    setPriorityIsVisible
}){
    const { Option, OptGroup } = Select;

    const clearIconStyle = useRef({ height:"1em", width:"1em", fontSize:14 }).current;
    const viewModeOptions = useRef([
        { value: "entity_view", label: "Vue par entités" },
        { value: "account_view", label: "Vue par comptes" },
        { value: "affect_view", label: "Vue par affectations" },
        { value: "record_view", label: "Vue par factures" },
    ]).current;

    useEffect(() => {
        if( currentSelectedMenu === 'billing_synt' ) setViewMode('entity_view');
    }, [currentSelectedMenu, setViewMode]);

    // TOGGLE VISIBILITY GRID COLUMNS
    useEffect(() => {
        setActiveLeftMenuKeyGroup(currentSelectedMenu.split('_')[0]);
        if( !['reporting_table', 'billing_int', 'billing_ext'].includes(currentSelectedMenu) && attrAreVisible ){
            setAttrAreVisible(!attrAreVisible);
        } 
     
        if( ['reporting_table', 'billing_int', 'billing_ext'].includes(currentSelectedMenu) && attrAreVisible && gridApi ){
            gridApi.applyColumnState({
                state: [
                    { colId: 'atr_propart', hide: !attrAreVisible },
                    { colId: 'atr_zonegeo', hide: !attrAreVisible },
                    { colId: 'atr_mission', hide: !attrAreVisible }
                ],
            });
        } 
        if( !['reporting_table'].includes(currentSelectedMenu) ){
            setAssignmentIsVisible(false);
            setPriorityIsVisible(false);
        } 
        if( ['reporting_table'].includes(currentSelectedMenu) && gridApi ){
            gridApi.applyColumnState({
                state: [
                    { colId: 'assignment', hide: !assignmentIsVisible },
                    { colId: 'priority', hide: !priorityIsVisible },
                ],
            });
        } 
    }, [
        currentSelectedMenu, 
        attrAreVisible, 
        assignmentIsVisible, 
        priorityIsVisible, 
        gridApi, 
        setActiveLeftMenuKeyGroup, 
        setAttrAreVisible,
        setAssignmentIsVisible,
        setPriorityIsVisible
    ])

    //EXTERNAL FILTERS
    const handleExternalFilterChange = ( value, name ) => {
        switch( value ){
            case 'Toutes affectations' :
                value = 'all';
                break;
            case 'Sans affectation' :
                value = 'no_affect';
                break;
            default : 
                break;
        }

        setExternalFilter(prevValue => ({...prevValue, [name]: value}))
    }

    return (
        <Card 
            variant="borderless" 
            style={{ boxShadow: "none" }}
            styles={{
                body: {
                    padding: '15px 0'
                }
            }}
        >
            <Space direction="vertical">
                <Input 
                    placeholder="Votre recherche..."
                    value={externalFilters.searchbar}
                    allowClear={{clearIcon: <Delete {...clearIconStyle}/>}}
                    onChange={({ currentTarget }) => handleExternalFilterChange(currentTarget.value, "searchbar")}
                />
                {
                    activeLeftMenuKeyGroup === 'reporting' &&
                        <Select 
                            placeholder="Affectation"
                            value={externalFilters.user}
                            className="w-100"
                            // disabled={activeLeftMenuKeyGroup !== "reporting"}
                            onChange={(_, opt) => handleExternalFilterChange(opt.children, "user")}
                            virtual={false}
                            filterOption={(inputValue, option) =>
                                option.title.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                            }
                        > 
                            {
                                isNonEmptyArray(users) &&
                                    <>
                                        <Option value="all">Toutes affectations</Option>
                                        <Option value="no_affect">Sans affectation</Option>
                                        <OptGroup 
                                            label={<Divider className="my-1"/>}
                                        >
                                        {
                                            users.map((user, index) => {
                                                const { label, value } = user;

                                                return(
                                                    <Option key={index} value={value}>{label}</Option>
                                                );
                                            }) 
                                        } 
                                        </OptGroup>
                                    </>
                            }
                        </Select>

                }
            </Space>

            {
                currentSelectedMenu === 'billing_synt' && 
                    <>
                        <Divider orientation="left">Vues</Divider>
                        <Space 
                            direction="vertical" 
                            style={{ display: 'flex' }}
                        >
                            <Select 
                                value={viewMode}
                                options={viewModeOptions}
                                defaultValue={defaultViewMode}
                                className="w-100"
                                onChange={setViewMode}
                            >
                                
                            </Select>
                        </Space>
                    </>
            }

            {
                ['reporting_table', 'billing_int', 'billing_ext'].includes(currentSelectedMenu) &&
                    <>
                        <Divider orientation="left">Colonnes</Divider>
                        <Space
                            direction="vertical"
                            size="small"
                            style={{ display: 'flex' }}
                        >
                            <Checkbox 
                                checked={attrAreVisible}
                                onChange={() => handleToggleColumns('attr')}
                            >
                                { attrAreVisible ? 'Masquer les colonnes d\'attribut' : 'Afficher les colonnes d\'attribut' }
                            </Checkbox>
                            {
                                ['reporting_table'].includes(currentSelectedMenu) &&
                                    <>
                                        <Checkbox 
                                            checked={assignmentIsVisible}
                                            onChange={() => handleToggleColumns('assignment')}
                                        >
                                            { assignmentIsVisible ? 'Masquer la colonne d\'affectation' : 'Afficher la colonne d\'affectation' }
                                        </Checkbox>
                                        <Checkbox 
                                            checked={priorityIsVisible}
                                            onChange={() => handleToggleColumns('priority')}
                                        >
                                            { priorityIsVisible ? 'Masquer la colonne de priorité de relance' : 'Afficher la colonne de priorité de relance' }
                                        </Checkbox>
                                    </>
                            }
                        </Space>
                    </>
            }   
        </Card>
    );
}